import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Row, Col, Button, Card, Pagination } from "react-bootstrap";
import { getReservations, cancelReservation } from "../Services";
import { toast } from "react-toastify";
import configs from "../config.json";
import * as PropTypes from "prop-types";

var QRCode = require("qrcode.react");

class Reservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reservations: [],
      items: [],
      offset: 1,
      lastPage: 1,
      paginateItems: [],
      showCancelModal: false,
      cancelId: null,
    };
  }

  componentDidMount() {
    this.updateReservations();
  }

  componentWillUpdate() {
    var user = localStorage.getItem("user");
    if (!user) {
      this.props.history.push("/");
    }
  }
  showCancelModal = (id) => {
    this.setState({ showCancelModal: true, cancelId: id });
  };

  hideCancelModal = () => {
    this.setState({ showCancelModal: false, cancelId: null });
  };

  confirmCancel = () => {
    const id = this.state.cancelId;
    this.setState({ showCancelModal: false, cancelId: null }, () => {
      this.cancelReservation(id);
    });
  };
  updateReservations = () => {
    var user = localStorage.getItem("user");
    if (!user) {
      this.props.history.push("/");
    } else {
      user = JSON.parse(user);
      getReservations(user._id)
        .then((res) => {
          this.setState({ reservations: res.reverse() }, () =>
            this.paginateReservations()
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  cancelReservation = (id) => {
    //var c = window.confirm("The reservation " + id + " will be cancelled");
    // if (c) {
    cancelReservation(id)
      .then((res) => {
        toast.success("Successfully cancelled reservation " + id);
        this.updateReservations();
      })
      .catch((err) => {
        console.log(err);
      });
    //}
  };

  render() {
    const PaginatedReservations = this.getPagination(this.state.paginateItems);
    return (
      <>
        <Row
          style={{
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <ReservationList reservations={this.state.reservations} />
          {this.state.reservations.length > 0 && (
            <>
              <Row style={{ width: "75%", paddingTop: 20, paddingLeft: 15 }}>
                {PaginatedReservations}
              </Row>
              {this.state.items.map((reservation, i) => {
                return reservation;
              })}
              <Row style={{ width: "75%", paddingTop: 20, paddingLeft: 15 }}>
                {PaginatedReservations}
              </Row>
            </>
          )}
        </Row>
        <Modal
          show={this.state.showCancelModal}
          onHide={this.hideCancelModal}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Cancel Reservation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to cancel reservation{" "}
            <b>{this.state.cancelId}</b>?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.hideCancelModal}>
              No
            </Button>
            <Button variant="danger" onClick={this.confirmCancel}>
              Yes, Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  getPagination(paginateItems) {
    return (
      <Pagination>
        <Pagination.First onClick={() => this.pageChange(1)} />
        {paginateItems}
        <Pagination.Last onClick={() => this.pageChange(this.state.lastPage)} />
      </Pagination>
    );
  }

  paginateReservations = () => {
    let items = [];
    const offset = (this.state.offset - 1) * 5;

    for (let number = offset; number < offset + 5; number++) {
      const reservation = this.state.reservations[number];
      if (reservation) {
        var tempDate = new Date(reservation.date);
        var bookingDate = new Date(
          tempDate.getFullYear(),
          tempDate.getMonth(),
          tempDate.getDate(),
          reservation.time.slice(0, 2),
          reservation.time.slice(3, 5),
          0,
          0
        );
        bookingDate.setHours(bookingDate.getHours() - 12);
        const disabled = bookingDate < new Date();

        const url = configs.frontendURL + "/ticket/" + reservation._id;

        items.push(
          <Row style={{ width: "75%", position: "relative" }} key={number}>
            <Col>
              <Card
                style={{
                  padding: 10,
                  marginTop: 10,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Watermark if cancelled */}
                {reservation.status === "cancelled" && (
                  <div className="cancelled-watermark">CANCELLED</div>
                )}
                <Row>
                  <Col>
                    Reference No :{" "}
                    {reservation.payment &&
                      reservation.payment.application_number}
                  </Col>
                  <Col align="right">
                    {reservation.date} {reservation.time}
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        From <b>{reservation.from}</b> to{" "}
                        <b>{reservation.to}</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col>Transport Mode : {reservation.train}</Col>
                    </Row>
                    <Row>
                      <Col>Class : {reservation.trainClass}</Col>
                    </Row>
                    <Row>
                      <Col>Quantity : {reservation.qty}</Col>
                    </Row>
                  </Col>
                  <Col align="right">
                    <QRCode value={url} />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    Payment Method : <b>{reservation.paymentMethod}</b>
                  </Col>
                </Row>
                <Row>
                  <br />
                  <Col>Amount : {reservation.amount.toFixed(2)}</Col>
                  <Col>Discount : {reservation.discount.toFixed(2)}</Col>
                  <Col align="right">
                    <b>Total :</b> {reservation.total.toFixed(2)}
                  </Col>
                </Row>
                <Row>
                  <Col style={{ paddingTop: 10 }} align="right">
                    <Button
                      variant="primary" // Blue button
                      size="sm" // Small size
                      style={{ marginRight: 16 }} // Space from Cancel button
                      onClick={() => {
                        const printWindow = window.open(
                          "",
                          "_blank",
                          "width=600,height=800"
                        );
                        if (printWindow) {
                          printWindow.document.write(`
        <html>
          <head>
            <title>Print Ticket</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 40px; text-align: center; }
              .qr { margin: 30px 0; }
              .info { margin-bottom: 20px; font-size: 18px; }
              h2 { margin-bottom: 10px; }
            </style>
          </head>
          <body>
            <h2>Ticket</h2>
            <div class="info">
              <div><b>Reference No:</b> ${
                reservation.payment && reservation.payment.application_number
              }</div>
              <div><b>From:</b> ${reservation.from} <b>To:</b> ${
                            reservation.to
                          }</div>
              <div><b>Date:</b> ${reservation.date} <b>Time:</b> ${
                            reservation.time
                          }</div>
              <div><b>Class:</b> ${reservation.trainClass}</div>
              <div><b>Quantity:</b> ${reservation.qty}</div>
              <div><b>Total:</b> ${reservation.total.toFixed(2)} SLE</div>
            </div>
            <div class="qr">
              <img src="${document
                .querySelector(`#qr-${reservation._id}`)
                .toDataURL()}" alt="QR Code" />
            </div>
            <button onclick="window.print()">Print</button>
          </body>
        </html>
      `);
                          printWindow.document.close();
                        }
                      }}
                      disabled={reservation.status === "cancelled"}
                    >
                      Print E-Ticket
                    </Button>
                    <QRCode
                      id={`qr-${reservation._id}`}
                      value={url}
                      style={{ display: "none" }}
                    />
                    <Button
                      disabled={disabled || reservation.status === "cancelled"}
                      variant="danger"
                      size="sm"
                      onClick={() => this.showCancelModal(reservation._id)}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        );
      }
    }
    let paginateItems = [];
    const lastPage = Math.ceil(this.state.reservations.length / 5);
    for (let number = 1; number <= lastPage; number++) {
      paginateItems.push(
        <Pagination.Item
          key={number}
          active={number === this.state.offset}
          onClick={() => this.pageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    this.setState({
      paginateItems: paginateItems,
      items: items,
      lastPage: lastPage,
    });
  };

  pageChange = (n) => {
    this.setState({ offset: n }, () => this.paginateReservations());
  };
}

export default Reservations;

function ReservationList(props) {
  return (
    <>
      {props.reservations.length <= 0 && (
        <Row style={{ width: "75%", padding: 10 }}>
          <Col>
            <Card>
              <Card.Body>No reservations</Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
}

ReservationList.propTypes = { reservations: PropTypes.any };
